import React from 'react'
import "./ThankYou.scss";

const ThankYou = () => {
    return (
        <div className="thank-you-page" onClick={() => window.open("https://www.ea.com/games/fifa/fifa-21/buy?utm_source=Ynet&utm_medium=Banner&utm_campaign=FIFA21%20Launch", "_blank")}>

        </div>
    )
}

export default ThankYou
